/**
 * Product card navigation — fast mobile taps + fallback when overlay link misses.
 * pointerup navigates before the synthetic click delay; sized <a> links stay native.
 */
(function () {
  const SKIP =
    '.grail-card-quick-cart, .quick-add, button, input, select, textarea, summary, details, modal-opener, quantity-popover, .grail-quick-icon';
  const MAX_MOVE = 12;

  function getCard(target) {
    return target.closest('.product-card-wrapper[data-product-url]');
  }

  function isSkippedTarget(target) {
    return Boolean(target.closest(SKIP));
  }

  function hasSizedLink(target, card) {
    const anchor = target.closest('a[href]');
    if (!anchor || !card.contains(anchor)) return false;
    const rect = anchor.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  let activeTap = null;
  let suppressClickUntil = 0;

  function navigate(card) {
    const url = card.getAttribute('data-product-url');
    if (!url) return;
    suppressClickUntil = Date.now() + 500;
    window.location.assign(url);
  }

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const card = getCard(event.target);
      if (!card || isSkippedTarget(event.target) || hasSizedLink(event.target, card)) return;

      activeTap = {
        card,
        pointerId: event.pointerId,
        x: event.clientX,
        y: event.clientY,
      };
      card.classList.add('is-card-tapped');
    },
    { passive: true }
  );

  function endTap(event) {
    if (!activeTap || event.pointerId !== activeTap.pointerId) return;

    const { card, x, y } = activeTap;
    activeTap = null;
    card.classList.remove('is-card-tapped');

    if (isSkippedTarget(event.target) || hasSizedLink(event.target, card)) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const moved = Math.hypot(event.clientX - x, event.clientY - y);
    if (moved > MAX_MOVE) return;

    navigate(card);
  }

  document.addEventListener('pointerup', endTap, { passive: true });
  document.addEventListener('pointercancel', () => {
    if (!activeTap) return;
    activeTap.card.classList.remove('is-card-tapped');
    activeTap = null;
  });

  document.addEventListener('click', (event) => {
    if (Date.now() < suppressClickUntil) return;
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const card = getCard(event.target);
    if (!card || isSkippedTarget(event.target) || hasSizedLink(event.target, card)) return;

    navigate(card);
  });
})();
